import {PageModel} from 'survey-core';
import {
  QUESTION_RISE_INTERSTITIAL,
  RiseInterstitialProps,
} from '../components/RiseInterstitialTemplate/RiseInterstitialBase';
import {CategoryType, RiseInterstitialPage} from '../../../types';

/**
 * Creates an interstitial page
 *
 */
export type InterstitialOptions = {
  name: string;
  isQuestion?: boolean;
  component: React.FC<RiseInterstitialProps & Record<string, any>>;
  visibleIf?: string;
  category?: CategoryType;
  hideProgressBar?: boolean;
  hideCategory?: boolean;
  showLogo?: boolean;
  autoAdvance?: boolean;
  // Hide the header back arrow on this page. Used for multi-step interstitials
  // (e.g. the SleepioRx intake wizard) whose internal steps SurveyJS can't
  // navigate — page-level back would jump out of the wizard, so it's suppressed.
  hideBackButton?: boolean;
  theme?: string | (() => string);
};
export const interstitial = ({
  name,
  component,
  visibleIf,
  category,
  hideProgressBar,
  hideCategory,
  showLogo,
  autoAdvance,
  hideBackButton,
  theme,
}: InterstitialOptions): RiseInterstitialPage => {
  return {
    visibleIf,
    name: 'page-' + name,
    riseProperties: {
      category,
      hideProgressBar,
      hideCategory,
      showLogo,
      autoAdvance,
      hideBackButton,
      theme,
    },
    elements: [
      {
        type: QUESTION_RISE_INTERSTITIAL,
        titleLocation: 'hidden',
        name,
        riseComponent: component,
      },
    ],
  };
};

/**
 * Looks for any questions on the page with the type of QUESTION_RISE_INTERSTITIAL
 */
export const isInterstitial = (page: PageModel) => {
  return page?.questions.some((q: any) => q?.jsonObj?.type === QUESTION_RISE_INTERSTITIAL);
};
